import { IntlShape } from 'react-intl';

const lmsBaseUrl = __JS_ENV_VARS__['JS_ENV_LMS_BASE_URL'];

export const createLessonDetailUrl = async (
  intl: IntlShape,
  lessonId: number | string,
  hasQuiz: boolean,
  showPrev: '0' | '1',
  showNext: '0' | '1',
): Promise<string> => {
  const url = new URL(`${lmsBaseUrl}/wp-json/mybrightlink/v1/lesson/detail`);
  url.searchParams.append('lesson_id', lessonId.toString() ?? '0');
  url.searchParams.append('mbl_web', '1');
  url.searchParams.append('show_mark_complete', !hasQuiz ? '1' : '0');
  url.searchParams.append('show_quiz_button', hasQuiz ? '1' : '0');
  url.searchParams.append(
    'practice_button',
    intl.formatMessage({ id: 'resources.lesson.practice' }),
  );
  url.searchParams.append(
    'complete_button',
    intl.formatMessage({ id: 'resources.lesson.mark-complete' }),
  );
  url.searchParams.append('show_next', showNext);
  url.searchParams.append('show_prev', showPrev);

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
    },
  });
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};
